import { render, staticRenderFns } from "./SkuPrice.vue?vue&type=template&id=da0b6b18&scoped=true&"
import script from "./SkuPrice.vue?vue&type=script&lang=js&"
export * from "./SkuPrice.vue?vue&type=script&lang=js&"
import style0 from "./SkuPrice.vue?vue&type=style&index=0&id=da0b6b18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0b6b18",
  null
  
)

export default component.exports